var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2195 2.28571H10.0195C7.96846 2.28571 6.00146 3.10047 4.55117 4.55075C3.10089 6.00103 2.28613 7.96803 2.28613 10.019V21.219C2.28613 25.4857 5.7528 28.9524 10.0195 28.9524H21.2195C23.2705 28.9524 25.2375 28.1376 26.6878 26.6873C28.138 25.2371 28.9528 23.2701 28.9528 21.219V10.019C28.9528 5.75237 25.4861 2.28571 21.2195 2.28571ZM24.6042 17.5371V24.6038H20.8842V18.0305C20.8842 17.5354 20.6876 17.0606 20.3375 16.7105C19.9874 16.3605 19.5126 16.1638 19.0176 16.1638C17.9909 16.1638 17.1642 17.0038 17.1642 18.0305V24.6038H13.4442V13.4438H17.1642V14.9238C17.8042 13.8838 19.1242 13.1905 20.2576 13.1905C21.4104 13.1905 22.516 13.6484 23.3311 14.4636C24.1463 15.2787 24.6042 16.3843 24.6042 17.5371ZM10.6948 10.6944C10.2747 11.1145 9.70498 11.3505 9.11089 11.3505C7.87089 11.3505 6.85756 10.3505 6.85756 9.11047C6.85756 8.51285 7.09496 7.9397 7.51755 7.51712C7.94013 7.09454 8.51327 6.85713 9.11089 6.85713C10.3509 6.85713 11.3509 7.87047 11.3509 9.11047C11.3509 9.70455 11.1149 10.2743 10.6948 10.6944ZM10.9642 13.4438V24.6038H7.27089V13.4438H10.9642Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a38dcc460acdfad46f695f7a362f27f1.svg";
export { ForwardRef as ReactComponent };